/**
 * Sidebar expand/collapse state helpers.
 * Only one menu branch may be open at a time (plus optional parent keepOpenIds for nested groups).
 */

export function mergeExpandedMenus(prev, menuId, shouldOpen, keepOpenIds = []) {
  if (!shouldOpen) {
    return { ...prev, [menuId]: false };
  }

  const next = { [menuId]: true };
  keepOpenIds.forEach((id) => {
    if (id) next[id] = true;
  });
  return next;
}

export function toggleExpandedMenu(prev, menuId, keepOpenIds = []) {
  const isOpen = !!prev[menuId];
  return mergeExpandedMenus(prev, menuId, !isOpen, keepOpenIds);
}

/** Sync sidebar expansion to the active route — replaces prior expansions (single open branch). */
export function mergeRouteExpansions(prev, expansions) {
  if (!expansions || Object.keys(expansions).length === 0) return prev;

  const next = {};
  Object.entries(expansions).forEach(([key, value]) => {
    if (value) next[key] = true;
  });

  const prevOpen = Object.keys(prev).filter((key) => prev[key]);
  const nextOpen = Object.keys(next);
  if (
    prevOpen.length === nextOpen.length
    && nextOpen.every((key) => prev[key])
  ) {
    return prev;
  }

  return next;
}
